import React, { Component, PropTypes } from 'react';

import { TopicShape } from 'entities';
import AccordionCheckbox from 'components/Accordion/AccordionCheckbox';

class InterestsTopicCheckbox extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.topic !== this.props.topic;
  }

  render() {
    const { id, title, interestedIn } = this.props.topic;
    return (
      <AccordionCheckbox
        id={id}
        title={title}
        isChecked={interestedIn}
        onClick={this.props.onClick}
      />
    );
  }
}

InterestsTopicCheckbox.propTypes = {
  topic: TopicShape,
  onClick: PropTypes.func
};

export default InterestsTopicCheckbox;



/** WEBPACK FOOTER **
 ** ./src/members/Main/Interests/InterestsTopicCheckbox/index.js
 **/